import { render, staticRenderFns } from "./manageCustomModels.vue?vue&type=template&id=f0be1aa6&"
import script from "./manageCustomModels.vue?vue&type=script&lang=js&"
export * from "./manageCustomModels.vue?vue&type=script&lang=js&"
import style0 from "./manageCustomModels.vue?vue&type=style&index=0&id=f0be1aa6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports